import { DateFormat, Languages } from '@dark-portal/backend-planora';
import i18n from 'i18next';

export function getDefaultDateFormatBasedOnLang(): DateFormat {
  if (i18n.language === Languages.PL) {
    return DateFormat.DD_MM_YYYY_DASH;
  }

  return DateFormat.DD_MM_YYYY_SLASH;
}
